import React, { useEffect, useState, createElement } from 'react';
import { Check, ChevronDown, ChevronUp, Clock, ShieldCheck, Star, BookOpen, Map, Calendar, FileText, Users, Globe, ArrowRight } from 'lucide-react';
import { CTAButton } from '../components/CTAButton';
import { PurchasePopup } from '../components/PurchasePopup';
import { TestimonialCard } from '../components/TestimonialCard';
import { BonusCard } from '../components/BonusCard';
export function LandingPage() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  // Meta Pixel initialization
  useEffect(() => {
    // Create and inject Meta Pixel script
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '2503744536694212');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    return () => {
      // Cleanup: remove script on unmount
      document.head.removeChild(script);
    };
  }, []);
  const toggleFaq = (index: number) => {
    setOpenFaq(openFaq === index ? null : index);
  };
  const scrollToPricing = () => {
    const element = document.getElementById('pricing');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="min-h-screen bg-[#FAF8F3] font-sans text-gray-800 selection:bg-[#D4A574]/30" data-id="element-36">
      <PurchasePopup data-id="element-37" />

      {/* Top Banner */}
      <div className="bg-[#8B4513] text-white text-center py-2 px-4 font-bold text-sm md:text-base sticky top-0 z-40 shadow-md" data-id="element-38">
        🔥 OFERTA LIMITADA: 70% DE DESCUENTO HOY
      </div>

      {/* Hero Section */}
      <header className="relative pt-4 pb-8 px-4 overflow-hidden" data-id="element-39">
        <div className="max-w-4xl mx-auto text-center" data-id="element-40">
          <div className="inline-block bg-[#D4A574]/20 text-[#6B3410] px-4 py-1 rounded-full text-sm font-bold mb-3 border border-[#D4A574]" data-id="element-41">
            📜 MEGAPACK HISTORIA LISTA™
          </div>

          <h1 className="text-3xl md:text-6xl font-black text-gray-900 mb-0.5 leading-tight tracking-tight" data-id="element-42">
            Todo tu año de Historia{' '}
            <span className="text-[#8B4513] underline decoration-4 decoration-[#D4A574]" data-id="element-43">
              resuelto
            </span>
            .
          </h1>

          <div className="my-0.5 relative group cursor-pointer" onClick={scrollToPricing} data-id="element-44">
            <img src="https://cdn.magicpatterns.com/uploads/nEvQHW9BBc98LyiwxKbvth/PROYECTOS_Anuales_(2).png" alt="MegaPack Historia Lista - Colección Completa" className="relative w-full max-w-xs mx-auto transform transition duration-300 group-hover:scale-[1.02]" style={{
            mixBlendMode: 'multiply',
            backgroundColor: 'transparent'
          }} data-id="element-45" />
          </div>

          <p className="text-lg md:text-2xl text-gray-600 mb-4 max-w-2xl mx-auto leading-snug" data-id="element-46">
            El sistema definitivo de material de historia listo para usar en
            todos los niveles educativos.
            <span className="block mt-2 font-medium text-gray-800 leading-tight" data-id="element-47">
              Sin improvisar. Sin perder horas. Sin estrés.
            </span>
          </p>

          <CTAButton text="SI, QUIERO EL MEGAPACK HISTORIA LISTA™" subtext="Garantía de satisfacción de 7 días" data-id="element-48" />

          <div className="mt-6 flex items-center justify-center gap-2 text-sm text-gray-500" data-id="element-49">
            <div className="flex -space-x-2" data-id="element-50">
              {[1, 2, 3, 4, 5].map(i => <div key={i} className="w-8 h-8 rounded-full bg-gray-200 border-2 border-white overflow-hidden" data-id="element-51">
                  <img src={`https://i.pravatar.cc/100?img=${i + 10}`} alt="User" data-id="element-52" />
                </div>)}
            </div>
            <span data-id="element-53">Más de 1,200 docentes ya lo usan</span>
          </div>
        </div>
      </header>

      {/* Problem Section */}
      <section className="py-16 px-4 bg-white border-y border-[#D4A574]/30" data-id="element-54">
        <div className="max-w-3xl mx-auto" data-id="element-55">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-8 text-center" data-id="element-56">
            Si eres docente de Historia, esto te va a resultar muy familiar…
          </h2>

          <div className="space-y-6 text-lg text-gray-700 leading-relaxed" data-id="element-57">
            <p data-id="element-58">
              Llegas a casa cansado/a… Sabes que tienes que planificar… Abres la
              computadora…{' '}
              <span className="font-bold text-[#8B4513]" data-id="element-59">
                Y empiezas otra vez de cero.
              </span>
            </p>

            <p data-id="element-60">
              Buscando textos. Buscando actividades. Buscando mapas. Buscando
              líneas de tiempo. Buscando formas de explicar procesos complejos
              de manera clara.
            </p>

            <div className="bg-[#D4A574]/10 p-6 rounded-xl border-l-4 border-[#8B4513] my-8" data-id="element-61">
              <p className="font-medium italic" data-id="element-62">
                "Y el tiempo vuela. Y el cansancio crece. Y tu cabeza no se
                apaga."
              </p>
            </div>

            <p data-id="element-63">No porque no sepas enseñar. No porque no seas buen/a docente.</p>

            <p className="text-xl font-bold text-gray-900" data-id="element-64">
              👉 Sino porque estás intentando sostener todo el año sin un
              sistema que te sostenga a ti.
            </p>
          </div>
        </div>
      </section>

      {/* Agitation Section */}
      <section className="py-16 px-4 bg-gray-50" data-id="element-65">
        <div className="max-w-4xl mx-auto" data-id="element-66">
          <h2 className="text-3xl font-bold text-center mb-12" data-id="element-67">
            El problema real
          </h2>

          <div className="grid md:grid-cols-2 gap-8 items-center mb-12" data-id="element-68">
            <div data-id="element-69">
              <p className="text-lg mb-4 font-medium" data-id="element-70">
                Hoy el sistema educativo te exige:
              </p>
              <ul className="space-y-3" data-id="element-71">
                {['Planificar', 'Crear material', 'Adaptar contenidos', 'Motivar estudiantes', 'Cumplir programas', 'Preparar evaluaciones'].map((item, i) => <li key={i} className="flex items-center gap-3 bg-white p-3 rounded-lg shadow-sm border border-gray-100" data-id="element-72">
                    <div className="w-2 h-2 rounded-full bg-[#8B4513]" data-id="element-73"></div>
                    {item}
                  </li>)}
              </ul>
            </div>
            <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-200 text-center" data-id="element-74">
              <h3 className="text-xl font-bold mb-4 text-gray-900" data-id="element-75">
                El resultado:
              </h3>
              <div className="space-y-4" data-id="element-76">
                <div className="p-4 bg-[#8B4513]/10 rounded-lg text-[#6B3410] font-medium" data-id="element-77">
                  Vives improvisando
                </div>
                <div className="p-4 bg-[#8B4513]/10 rounded-lg text-[#6B3410] font-medium" data-id="element-78">
                  Llevando trabajo a casa
                </div>
                <div className="p-4 bg-[#8B4513]/10 rounded-lg text-[#6B3410] font-medium" data-id="element-79">
                  Sintiendo que nunca terminas
                </div>
                <div className="p-4 bg-[#8B4513]/10 rounded-lg text-[#6B3410] font-medium" data-id="element-80">
                  Agotado/a antes de mitad de año
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Solution Section */}
      <section className="py-20 px-4 bg-[#D4A574]/20 relative overflow-hidden" data-id="element-81">
        <div className="absolute inset-0 opacity-10 bg-[url('https://www.transparenttextures.com/patterns/aged-paper.png')]" data-id="element-82"></div>
        <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-83">
          <span className="text-[#8B4513] font-bold tracking-widest uppercase text-sm mb-4 block" data-id="element-84">
            La Solución Definitiva
          </span>
          <h2 className="text-4xl md:text-5xl font-black text-gray-900 mb-8" data-id="element-85">
            📜 MEGAPACK HISTORIA LISTA™
          </h2>
          <p className="text-xl md:text-2xl text-gray-700 mb-10 max-w-2xl mx-auto" data-id="element-86">
            Un sistema completo de materiales históricos organizados por nivel,
            período y región, para que nunca más tengas que empezar de cero.
          </p>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-12 text-center" data-id="element-87">
            {[{
            icon: Check,
            text: 'Todo listo'
          }, {
            icon: ShieldCheck,
            text: 'Todo probado'
          }, {
            icon: FileText,
            text: 'Todo ordenado'
          }, {
            icon: Star,
            text: 'Todo usable'
          }].map((item, i) => <div key={i} className="bg-white/80 backdrop-blur-sm p-4 rounded-xl border border-[#D4A574]" data-id="element-88">
                <item.icon className="w-8 h-8 mx-auto mb-2 text-[#8B4513]" data-id="element-89" />
                <span className="font-bold text-gray-900" data-id="element-90">{item.text}</span>
              </div>)}
          </div>

          <CTAButton text="QUIERO ACCESO INMEDIATO" data-id="element-91" />
        </div>
      </section>

      {/* What's Included */}
      <section className="py-16 px-4" data-id="element-92">
        <div className="max-w-5xl mx-auto" data-id="element-93">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-gray-900" data-id="element-94">
            ¿Qué incluye?
          </h2>

          <div className="grid md:grid-cols-2 gap-12" data-id="element-95">
            <div className="space-y-6" data-id="element-96">
              {[{
              icon: BookOpen,
              title: '5 cuadernillos digitales',
              desc: 'Formato PDF, organizados por grandes períodos históricos: Historia I, II, III, IV y V.'
            }, {
              icon: Clock,
              title: 'Contenidos ordenados',
              desc: 'Secuenciados por ejes históricos: sociedades antiguas, Edad Media, Edad Moderna, procesos latinoamericanos y mundo contemporáneo.'
            }, {
              icon: FileText,
              title: 'Actividades prácticas',
              desc: 'Propuestas de trabajo pensadas para acompañar tus clases y facilitar la planificación.'
            }, {
              icon: Map,
              title: 'Recursos visuales',
              desc: 'Gráficos, líneas del tiempo y esquemas para apoyar las explicaciones en el aula.'
            }, {
              icon: Star,
              title: 'Acceso inmediato',
              desc: 'Base organizada de recursos, evitando empezar cada tema desde cero.'
            }].map((item, i) => <div key={i} className="flex gap-4" data-id="element-97">
                  <div className="bg-[#D4A574]/20 p-3 rounded-lg h-fit text-[#6B3410]" data-id="element-98">
                    <item.icon className="w-6 h-6" data-id="element-99" />
                  </div>
                  <div data-id="element-100">
                    <h3 className="font-bold text-lg text-gray-900" data-id="element-101">
                      {item.title}
                    </h3>
                    <p className="text-gray-600" data-id="element-102">{item.desc}</p>
                  </div>
                </div>)}
            </div>

            <div className="bg-gray-50 p-8 rounded-2xl border border-gray-200" data-id="element-103">
              <h3 className="font-bold text-xl mb-6 flex items-center gap-2" data-id="element-104">
                <Globe className="w-5 h-5 text-[#8B4513]" data-id="element-105" />
                Incluye material específico de:
              </h3>
              <div className="grid grid-cols-2 gap-3 mb-8" data-id="element-106">
                {['🇲🇽 México', '🇨🇴 Colombia', '🇨🇱 Chile', '🇺🇾 Uruguay', '🇪🇨 Ecuador', '🇵🇪 Perú', '🇪🇸 España', '🇦🇷 Argentina', '🇵🇦 Panamá', '🇨🇷 Costa Rica', '🇵🇾 Paraguay', '🇺🇸 Estados Unidos'].map((country, i) => <div key={i} className="bg-white px-3 py-2 rounded shadow-sm text-sm font-medium border border-gray-100" data-id="element-107">
                    {country}
                  </div>)}
              </div>

              <h3 className="font-bold text-xl mb-6 flex items-center gap-2" data-id="element-108">
                <FileText className="w-5 h-5 text-[#8B4513]" data-id="element-109" />
                Material listo para:
              </h3>
              <ul className="space-y-2" data-id="element-110">
                {['📝 Actividades', '📋 Evaluaciones', '🗺 Mapas históricos', '📊 Esquemas y cuadros', '📆 Planificaciones anuales', '📚 Guías docentes', '📄 Fichas imprimibles', '🧠 Actividades de comprensión', '🎯 Proyectos escolares'].map((item, i) => <li key={i} className="text-gray-700 text-sm md:text-base" data-id="element-111">
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-16 px-4 bg-[#D4A574]/10" data-id="element-112">
        <div className="max-w-6xl mx-auto" data-id="element-113">
          <div className="grid md:grid-cols-2 gap-8 md:gap-16" data-id="element-114">
            {/* Student Benefits */}
            <div className="bg-white p-8 rounded-2xl shadow-lg border-t-4 border-[#8B4513]" data-id="element-115">
              <div className="flex items-center gap-3 mb-6" data-id="element-116">
                <div className="bg-[#D4A574]/20 p-3 rounded-full text-[#6B3410]" data-id="element-117">
                  <Users className="w-8 h-8" data-id="element-118" />
                </div>
                <h3 className="text-2xl font-bold text-gray-900" data-id="element-119">
                  ¿Qué van a lograr tus estudiantes?
                </h3>
              </div>
              <ul className="space-y-4" data-id="element-120">
                {['Comprender la Historia paso a paso', 'Relacionar hechos históricos', 'Participar más en clase', 'Pensar de forma crítica', 'Disfrutar las clases', 'Mejorar en evaluaciones', 'Sentirse seguros'].map((item, i) => <li key={i} className="flex items-center gap-3" data-id="element-121">
                    <Check className="w-5 h-5 text-[#8B4513] flex-shrink-0" data-id="element-122" />
                    <span className="text-gray-700" data-id="element-123">{item}</span>
                  </li>)}
              </ul>
            </div>

            {/* Teacher Benefits */}
            <div className="bg-white p-8 rounded-2xl shadow-lg border-t-4 border-[#8B4513]" data-id="element-124">
              <div className="flex items-center gap-3 mb-6" data-id="element-125">
                <div className="bg-[#D4A574]/20 p-3 rounded-full text-[#6B3410]" data-id="element-126">
                  <Star className="w-8 h-8" data-id="element-127" />
                </div>
                <h3 className="text-2xl font-bold text-gray-900" data-id="element-128">
                  ¿Qué vas a lograr tú?
                </h3>
              </div>
              <ul className="space-y-4" data-id="element-129">
                {['Ahorrar horas todas las semanas', 'Dejar de improvisar', 'Tener respaldo profesional', 'Cubrir todo el programa', 'Dar clases más claras', 'Volver a disfrutar enseñar'].map((item, i) => <li key={i} className="flex items-center gap-3" data-id="element-130">
                    <Check className="w-5 h-5 text-[#8B4513] flex-shrink-0" data-id="element-131" />
                    <span className="text-gray-700" data-id="element-132">{item}</span>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Bonuses Section */}
      <section className="py-16 px-4 bg-white" data-id="element-133">
        <div className="max-w-6xl mx-auto" data-id="element-134">
          <div className="text-center mb-12" data-id="element-135">
            <span className="bg-[#8B4513]/10 text-[#6B3410] px-4 py-1 rounded-full text-sm font-bold uppercase tracking-wide" data-id="element-136">
              Solo por hoy
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mt-4 mb-4" data-id="element-137">
              🎁 BONOS EXCLUSIVOS (GRATIS HOY)
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-138">
              Llévate estos 3 recursos adicionales totalmente gratis al adquirir
              el MegaPack hoy.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8" data-id="element-139">
            <BonusCard number={1} title="PLANIFICACION ANUAL + TRIMESTRAL 2026" description="Plantillas listas para usar de 1 a 5: objetivos, contenidos por trimestre." imageUrl="https://cdn.magicpatterns.com/uploads/qqsm8Sc6s7VZzr8gYQsano/21.png" data-id="element-140" />
            <BonusCard number={2} title="ACTIVIDADES LISTAS PARA USAR" description="20 actividades por cada año (1 a 5): ejercicios, fuentes históricas, mapas, lineas del tiempo, análisis, cuadros comparativos y preguntas guiadas." imageUrl="https://cdn.magicpatterns.com/uploads/18bhFND7qqLKbvxvfEmXp6/22.png" data-id="element-141" />
            <BonusCard number={3} title="PACK DE LINEAS DEL TIEMPO" description="Lineas del tiempo listas para imprimir: antigüedad, Edad Media, revoluciones, historia latinoamericana y siglo XX." imageUrl="https://cdn.magicpatterns.com/uploads/m4a1jYbTzZYti11qZPJPHc/23.png" data-id="element-142" />
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section id="pricing" className="py-20 px-4 bg-[#D4A574]/10 border-y border-[#D4A574]/30" data-id="element-143">
        <div className="max-w-3xl mx-auto text-center" data-id="element-144">
          <div className="bg-white p-8 md:p-12 rounded-3xl shadow-2xl border-2 border-[#8B4513] relative overflow-hidden" data-id="element-145">
            <div className="absolute top-0 right-0 bg-[#8B4513] text-white px-8 py-2 font-bold transform rotate-45 translate-x-8 translate-y-4 shadow-md" data-id="element-146">
              -70% OFF
            </div>

            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2" data-id="element-147">
              Pack Completo de Historia 1-5
            </h2>
            <p className="text-[#8B4513] font-bold mb-8 text-lg" data-id="element-148">
              + 3 BONUS EXCLUSIVOS DE REGALO
            </p>

            <div className="flex flex-col items-center justify-center mb-8" data-id="element-149">
              <span className="text-gray-400 text-xl line-through font-medium" data-id="element-150">
                Antes $49.99 USD
              </span>
              <div className="flex items-center gap-2" data-id="element-151">
                <span className="text-2xl font-bold text-gray-700" data-id="element-152">HOY</span>
                <span className="text-6xl md:text-7xl font-black text-[#8B4513] tracking-tight" data-id="element-153">
                  $12.99
                </span>
                <span className="text-xl font-bold text-gray-500 self-end mb-2" data-id="element-154">
                  USD
                </span>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-left max-w-lg mx-auto mb-10" data-id="element-155">
              {['Acceso inmediato', 'Descarga ilimitada', 'Garantía de 7 días', 'Pagas en tu moneda local'].map((item, i) => <div key={i} className="flex items-center gap-2" data-id="element-156">
                  <div className="bg-[#8B4513]/10 p-1 rounded-full" data-id="element-157">
                    <Check className="w-4 h-4 text-[#8B4513]" data-id="element-158" />
                  </div>
                  <span className="text-gray-700 font-medium" data-id="element-159">{item}</span>
                </div>)}
            </div>

            <a href="https://checkout7.edulabs.online/cart/44519429832773:1" className="group relative inline-flex flex-col items-center justify-center bg-[#8B4513] hover:bg-[#A0522D] text-white py-3 px-6 rounded-lg shadow-md hover:shadow-lg hover:-translate-y-0.5 transition-all duration-300 ease-out border-b-2 border-[#6B3410] w-full" data-id="element-160">
              <div className="flex items-center gap-2 text-base md:text-lg font-bold uppercase tracking-wide text-center" data-id="element-161">
                SI, QUIERO EL MEGAPACK HISTORIA LISTA™
                <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-162" />
              </div>
            </a>

            <p className="mt-4 text-xs text-gray-500" data-id="element-163">
              Pago seguro y encriptado. Recibes el acceso a tu email
              inmediatamente.
            </p>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-16 px-4 bg-white" data-id="element-164">
        <div className="max-w-6xl mx-auto" data-id="element-165">
          <h2 className="text-3xl font-bold text-center mb-12 text-gray-900" data-id="element-166">
            Lo que dicen otros docentes
          </h2>

          <div className="grid md:grid-cols-3 gap-6" data-id="element-167">
            <TestimonialCard name="Laura Fernández" location="México" quote="Ahora tengo todo el año organizado. Nunca más improvisé Historia." data-id="element-168" />
            <TestimonialCard name="Carlos Méndez" location="Chile" quote="Mis clases son más claras y participativas." data-id="element-169" />
            <TestimonialCard name="Ana García" location="España" quote="Me ahorra horas de trabajo y mejora el rendimiento de mis alumnos." data-id="element-170" />
          </div>

          <div className="grid md:grid-cols-2 gap-6 mt-6 max-w-4xl mx-auto" data-id="element-171">
            <TestimonialCard name="María Rodríguez" location="Colombia" quote="Finalmente puedo planificar sin estrés. Mis estudiantes están más motivados." data-id="element-172" />
            <TestimonialCard name="José Martínez" location="Argentina" quote="La mejor inversión para mi carrera docente. Todo está perfectamente organizado." data-id="element-173" />
          </div>
        </div>
      </section>

      {/* Guarantee */}
      <section className="py-16 px-4 bg-gray-50" data-id="element-174">
        <div className="max-w-3xl mx-auto bg-white p-8 rounded-2xl shadow-lg border border-gray-200 flex flex-col md:flex-row items-center gap-8" data-id="element-175">
          <div className="flex-shrink-0" data-id="element-176">
            <img src="https://cdn-icons-png.flaticon.com/512/2550/2550223.png" alt="Garantía" className="w-32 h-32 object-contain" data-id="element-177" />
          </div>
          <div className="text-center md:text-left" data-id="element-178">
            <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-179">
              Garantía sin vueltas
            </h3>
            <p className="text-gray-700 mb-4" data-id="element-180">
              Prueba el MegaPack durante 7 días. Si no te sirve → te devolvemos
              el 100%. Sin preguntas. Sin letra chica.
            </p>
            <p className="text-sm font-bold text-[#8B4513] flex items-center justify-center md:justify-start gap-2" data-id="element-181">
              <ShieldCheck className="w-5 h-5" data-id="element-182" />
              Compra 100% Protegida
            </p>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-16 px-4 bg-white" data-id="element-183">
        <div className="max-w-3xl mx-auto" data-id="element-184">
          <h2 className="text-3xl font-bold text-center mb-10 text-gray-900" data-id="element-185">
            Preguntas Frecuentes
          </h2>

          <div className="space-y-4" data-id="element-186">
            {[{
            q: '¿El material es digital o físico?',
            a: 'Es 100% digital. Recibes acceso inmediato a todo el material en formato PDF de alta calidad para descargar e imprimir.'
          }, {
            q: '¿Sirve para clases virtuales y presenciales?',
            a: 'Sí, el material está diseñado para adaptarse a ambos formatos perfectamente.'
          }, {
            q: '¿Por cuánto tiempo tengo acceso?',
            a: 'El acceso es de por vida. Una vez que compras, el material es tuyo para siempre.'
          }, {
            q: '¿Necesito experiencia previa?',
            a: 'No, el material está diseñado para ser intuitivo y fácil de usar, tanto para docentes nuevos como experimentados.'
          }, {
            q: '¿Es compatible con el currículo de mi país?',
            a: 'Sí, cubrimos los temas universales de historia y procesos latinoamericanos comunes a todos los currículos de habla hispana.'
          }].map((item, i) => <div key={i} className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-187">
                <button onClick={() => toggleFaq(i)} className="w-full flex items-center justify-between p-4 text-left bg-gray-50 hover:bg-gray-100 transition-colors" data-id="element-188">
                  <span className="font-bold text-gray-900" data-id="element-189">{item.q}</span>
                  {openFaq === i ? <ChevronUp className="w-5 h-5 text-gray-500" data-id="element-190" /> : <ChevronDown className="w-5 h-5 text-gray-500" data-id="element-191" />}
                </button>
                {openFaq === i && <div className="p-4 bg-white text-gray-700 border-t border-gray-200" data-id="element-192">
                    {item.a}
                  </div>}
              </div>)}
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <footer className="py-20 px-4 bg-[#D4A574]/20 text-center" data-id="element-193">
        <div className="max-w-3xl mx-auto" data-id="element-194">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8" data-id="element-195">
            No pierdas otro año improvisando.
          </h2>
          <p className="text-gray-700 text-xl mb-10" data-id="element-196">
            Únete a los docentes que ya recuperaron su tiempo libre.
          </p>
          <CTAButton text="SI, QUIERO EL MEGAPACK HISTORIA LISTA™" data-id="element-197" />
          <p className="mt-8 text-gray-600 text-sm" data-id="element-198">
            © 2024 MegaPack Historia Lista. Todos los derechos reservados.
          </p>
        </div>
      </footer>
    </div>;
}